import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shown to customers on the counter iPad — mirrors the Kuber rate card poster.
const ORDER = [
  { key: "KUBER INSTALLMENTS", title: "Kuber Installments", note: "Flexible limits up to $10,000 — apply in the app", feature: true },
  { key: "KUBER PAYID", title: "PayID with Kuber", note: "Cheapest — only with Kuber" },
  { key: "KUBER APPLE / GOOGLE PAY", title: "Apple Pay & Google Pay" },
  { key: "KUBER AFTERPAY", title: "Afterpay" },
  { key: "KUBER KLARNA", title: "Klarna" },
  { key: "KUBER ZIP PAY", title: "Zip Pay" },
];

const FREE = [
  { key: "CASH", title: "Cash" },
  { key: "BANK TRANSFER", title: "Bank transfer" },
  { key: "PAYID", title: "PayID to our account" },
  { key: "CARD DEBIT", title: "Debit card" },
];

export default function PaymentOptions() {
  const { branch } = useParams();
  const [rates, setRates] = useState({});

  useEffect(() => {
    axios
      .get(`${API}/public/payment-rates`)
      .then(({ data }) => setRates(data.rates || {}))
      .catch(() => setRates({}));
  }, []);

  const rate = (key) => {
    const r = rates[key];
    if (!r) return null;
    const bits = [];
    if (r.pct) bits.push(`${r.pct}%`);
    if (r.fixed) bits.push(`$${Number(r.fixed).toFixed(2)}`);
    return bits.length ? bits.join(" + ") : "No fee";
  };

  return (
    <div
      className="min-h-screen bg-[#0B2027] px-6 py-10 text-white sm:px-10"
      data-testid="payment-options-page"
    >
      <div className="mx-auto max-w-3xl">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[0.35em] text-[#C5A059]">
          Dhunna Jewellers {String(branch || "").toUpperCase()}
        </p>
        <h1 className="mt-3 text-center text-4xl font-bold sm:text-5xl">Payment options</h1>
        <p className="mt-2 text-center text-base text-[#8FD3C7]">
          Simple, transparent pricing — pay your way.
        </p>

        <div className="mt-10 space-y-3" data-testid="payment-options-list">
          {ORDER.map((m) => {
            const r = rate(m.key);
            if (!r) return null;
            return (
              <div
                key={m.key}
                className={`flex items-center justify-between gap-4 border p-4 ${
                  m.feature
                    ? "border-[#C5A059] bg-[#12313A]"
                    : "border-[#1D3D46] bg-[#0F2A32]"
                }`}
                data-testid={`payment-option-${m.key}`}
              >
                <div>
                  <p className="text-lg font-bold sm:text-xl">{m.title}</p>
                  {m.note && <p className="text-sm text-[#8FD3C7]">{m.note}</p>}
                </div>
                <p
                  className={`tabular shrink-0 text-xl font-bold sm:text-2xl ${
                    m.feature ? "text-[#E6C079]" : "text-[#6FD3C0]"
                  }`}
                >
                  {r}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-8 border border-[#1D3D46] bg-[#0F2A32] p-4">
          <p className="text-sm font-semibold uppercase tracking-wider text-[#C5A059]">
            No extra charge
          </p>
          <p className="mt-2 text-base">
            {FREE.filter((f) => rates[f.key] && !rates[f.key].pct && !rates[f.key].fixed)
              .map((f) => f.title)
              .join(" · ")}
          </p>
        </div>

        <div className="mt-6 border-l-2 border-[#C5A059] bg-[#0F2A32] p-4 text-sm text-[#C9D6D9]">
          <p>
            Afterpay, Klarna and Zip Pay spending limits are set and controlled by each provider.
            If you have an available limit you can buy — otherwise simply choose another payment
            method.
          </p>
          <p className="mt-2 text-xs">
            In case of a refund, the processing fee is not refunded as it is charged by the bank.
          </p>
        </div>

        <p className="mt-8 text-center text-xs uppercase tracking-[0.25em] text-[#5E7C84]">
          Download the Kuber app to pay in seconds
        </p>
      </div>
    </div>
  );
}
